import { ReactNode } from 'react';
import { DefaultTheme, FlattenInterpolation, ThemeProps } from 'styled-components';

import Button from '~components/Button';

import * as S from './style';

export interface NudgeLoginDialogProps {
  message: ReactNode;
  subMessage?: ReactNode;
  buttonText?: string;
  inlineCss?: FlattenInterpolation<ThemeProps<DefaultTheme>>;
  onClick?: () => void;
}

export default function NudgeLoginDialog({
  message,
  subMessage,
  buttonText = '로그인',
  inlineCss,
  onClick,
}: NudgeLoginDialogProps) {
  return (
    <S.MessageWrapper inlineCss={inlineCss}>
      <S.Message>{message}</S.Message>
      {subMessage && <S.SubMessage>{subMessage}</S.SubMessage>}
      <S.ButtonGroup>
        <Button variant='magenta' size='sm' onClick={onClick}>
          {buttonText}
        </Button>
      </S.ButtonGroup>
    </S.MessageWrapper>
  );
}
